import BackgroundImageFromUrl from "../../components/parseImage/BackgroundImageFromUrl";
import QuestionNumberTag from "../../detail-components/QuestionNumberTag";
import ScrollRef from "../../detail-components/ScrollRef";
import jsonParser from "../helper/jsonParser";
import { useRef, useState } from "react";
import ConstantStrings from "../../constants/ConstantStrings";
import AudioIcon, {handleClickAudio, useAutoPlayAudio} from "./Assets/AudioIcon";

function QPrompt3_1({ data, order, isLast, playingAudioRef }) {
  const content = data?.content || data?.prompt;
  const contentText =
    content?.texts[0] !== null &&
      content?.texts[0] !== undefined &&
      content?.texts[0]?.length > 0
      ? jsonParser(content?.texts[0])
      : content?.texts[0];
  
  const audioLink = content?.audioLink;
  const audioRef = useRef(new Audio(ConstantStrings.IMAGE_URL + audioLink));
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);

  useAutoPlayAudio({
    content,
    audioRef,
    playingAudioRef,
    setIsAudioPlaying,
    slideId: data?._id || data.questionId,
    type: 0
  });

  return (
    <div>
      {!isLast &&
        <ScrollRef />}
      <BackgroundImageFromUrl
        objectId={content?.backgroundImage}
        className="has-text-centered has-background-kurio-main-color-white is-flex is-flex-direction-column is-justify-content-center is-align-items-center has-text-kurio-main-color-black "
        style={{
          borderRadius: "1rem 1rem 0 0",
          padding: "2rem",
          fontSize: "1.25rem",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        {data?.template.question !== null &&
          data?.template.question &&
          data?.template.question.length > 0 && (
            <div className="mb-4">
              <QuestionNumberTag number={order === 0 ? data?.order : order} />
            </div>
          )}

        <div className="content" style={{ maxWidth: "40rem" }}>
          {audioLink && playingAudioRef && <AudioIcon isPlaying={isAudioPlaying} onClick={() => handleClickAudio(audioRef, setIsAudioPlaying)} />}
          {contentText}
        </div>
      </BackgroundImageFromUrl>
    </div>
  );
}

export default QPrompt3_1;
